<div class="adv-card mgn-bottom-rem-1" [class.institution-pro]="job.employerProfileUrl">
    <div class="adv-card-tag-container"
        *ngIf="job.jobFlagApplicants > 0 || job.jobCountQuestion > 0 || (job.jobYear === 2026 && tabNextSeason)">
        <a *ngIf="job.jobCountQuestion > 0" class="btn tag-qa" (click)="navigateToJobView($event)" target="_self"
            title="Ver preguntas y respuestas del anuncio"> <i class="pj-ico pj-ico-alerta-mensajes"></i>
            <div class="wrap-qa-counter">
                <div class="qa-counter">{{job.jobCountQuestion}}</div>
            </div>
        </a>
        <span class="badge badge-primary custom-badge-2" *ngIf="tabNextSeason === true && job.jobYear === 2026">Año
            2026</span>
        <span class="badge custom-badge-2 bg-custom-green-9" *ngIf="job.jobFlagApplicants > 0">¡Sé de los primeros en
            postular!</span>
    </div>

    <div class="adv-card-body">
        <div class="adv-card-section align-self-center flex-wrap main-section">
            <div class="align-items-center d-flex flex-grow-1 inner-section">
                <a *ngIf="showInfoInstitution && job.employerProfileUrl" class="wrap-link-intitution-img"
                    [routerLink]="['/institucion/perfil/', job.employerProfileUrl]" target="_blank">
                    <div class="wrap-institution-img">
                        <img class="institution-img" loading="lazy" alt="Foto del colegio"
                            src="{{job.employerPhoto}}" />
                    </div>
                </a>
                <a *ngIf="showInfoInstitution && !job.employerProfileUrl && job.jobPrivate === 0"
                    class="wrap-link-intitution-img">
                    <div class="wrap-institution-img">
                        <img class="institution-img" loading="lazy" alt="Foto del colegio"
                            src="{{job.employerPhoto}}" />
                    </div>
                </a>
                <div *ngIf="showInfoInstitution && !job.employerProfileUrl && job.jobPrivate !== 0"
                    class="wrap-link-intitution-img">
                    <div class="wrap-institution-img">
                        <div class="wrap-institution-img font-size-20" style="background-color: #dcdcdc;">
                            <strong>AN</strong>
                        </div>
                    </div>
                </div>
                <a title="Ver anuncio" (click)="navigateToJobView($event)" role="button">
                    <h4 class="adv-title mgn-bottom-4 text-primary">{{job.jobTitle ? job.jobTitle :
                        job.jobPosition}}<ng-container *ngIf="job?.jobGradeFrom">, {{job.jobGradeFrom}}<ng-container
                                *ngIf="job.jobGradeFrom !== job.jobGradeTo"> a {{job.jobGradeTo}}</ng-container>
                        </ng-container>
                    </h4>
                </a>
            </div>
            <div class="flex-grow-1 inner-section">
                <div *ngIf="showInfoInstitution" class="adv-card-institution-name">{{job.employerName}} /
                    {{job.employerType}}
                </div>
                <div *ngIf="job.jobRemote !== 1 && job.jobRemote !== '1'" class="job-location"
                    [title]="job.jobAddress3 | jobCardAddressGroup">
                    <i class="pj-ico pj-ico-120 pj-ico-anuncio-ubicacion-empleo"></i>&nbsp;{{job.jobAddress3 |
                    jobCardAddressGroup}}
                </div>
                <span *ngIf="job.jobRemote === 1 || job.jobRemote === '1'"
                    class="badge badge-darkpink custom-badge font-weight-normal text-white"><i
                        class="badge-icon pj-ico pj-ico-laptop"></i>Trabajo
                    remoto</span>

            </div>
        </div>
        <div class="adv-card-section align-self-center features-section">
            <div class="inner-section">
                <span class="badge custom-badge badge-success font-weight-normal text-primary"><i
                        class="badge-icon pj-ico pj-ico-usuarios-publicar text-primary"></i>Contrato:
                    {{job.jobTypeContract}}</span>
                <span *ngIf="job.jobHoursFrom > 0 || job.jobHoursTo > 0"
                    class="badge custom-badge badge-success font-weight-normal text-primary"><i
                        class="badge-icon pj-ico pj-ico-anuncio-horas"></i>Horas
                    semanales: <ng-container *ngIf="job.jobHoursFrom  !== job.jobHoursTo ">
                        {{job.jobHoursFrom}} - {{job.jobHoursTo}}
                    </ng-container>
                    <ng-container *ngIf="job.jobHoursFrom  === job.jobHoursTo ">
                        {{job.jobHoursTo}}
                    </ng-container></span>
                <span class="badge custom-badge badge-success font-weight-normal text-primary"><i
                        class="badge-icon pj-ico pj-ico-vacantes-anuncio"></i>Vacantes:
                    {{job.jobVacancies}}</span>
                <div *ngIf="job.jobSalaryFrom > 0 || job.jobSalaryTo > 0">
                    <span class="badge badge-info custom-badge font-weight-normal text-primary"><i
                            class="badge-icon pj-ico pj-ico-anuncio-salario text-primary"></i>Renta:
                        <ng-container *ngIf="job.jobSalaryFrom  !== job.jobSalaryTo ">
                            ${{job.jobSalaryFrom | number:'':'es'}} -
                            ${{job.jobSalaryTo | number:'':'es'}}
                        </ng-container>
                        <ng-container *ngIf="job.jobSalaryFrom  === job.jobSalaryTo ">
                            ${{job.jobSalaryTo | number:'':'es'}}
                        </ng-container></span>
                </div>

                <i *ngFor="let b of job.jobBenefits" class="benefits-icon icon pj-ico {{b.benefitIcon}} text-primary"
                    data-container="#teacher-adv-card-group" data-toggle="popover" data-placement="top"
                    data-trigger="hover" [attr.data-content]="b.benefitName" tabindex="0"></i>

            </div>
            <div class="d-flex inner-section">
                <div class="meta-info-container">
                    <div class="meta-info">
                        <i class="icon pj-ico pj-ico-anuncio-experiencia text-primary"></i>&nbsp;Experiencia
                        requerida:&nbsp;
                        <span *ngIf="job.jobExperienceRequired===0" class="font-weight-bold">No
                            requerida.</span>
                        <span *ngIf="job.jobExperienceRequired===1" class="font-weight-bold">1
                            año.</span>
                        <span *ngIf="job.jobExperienceRequired>1" class="font-weight-bold">{{job.jobExperienceRequired}}
                            años.</span>
                    </div>
                    <div class="meta-info">
                        <i class="icon pj-ico pj-ico-anuncio-publicacion text-primary"></i>&nbsp;Publicado
                        hace
                        <span class="font-weight-bold">{{job.jobCreatedMinute | jobCardTimedif}}.</span>
                    </div>
                    <div class="meta-info">
                        <i class="icon pj-ico pj-ico-anuncio-vencimiento text-primary"></i>&nbsp;Vence
                        en&nbsp;
                        <span class="font-weight-bold">{{job.jobDeadlineMinute | jobCardTimedif}}.</span>
                    </div>
                </div>
            </div>

        </div>
        <div class="action-section adv-card-section align-self-center">
            <div class="inner-section">
                <a class="btn btn-outline-primary btn-sm" (click)="navigateToJobView($event)">Ver anuncio</a>

                <div *ngIf="job.isApplicationSent===1" class="wrap-popover-btn" tabindex="0"
                    data-container="#teacher-adv-card-group" data-toggle="popover" data-placement="left"
                    data-trigger="focus"
                    data-content="Ya postulaste a este anuncio, para conocer el estado de la publicación, haz clic en “Mis postulaciones”.">
                    <a class="btn btn-primary btn-sm disabled" href="#">Postular</a>
                </div>

                <a *ngIf="job.isApplicationSent===0" class="btn btn-primary btn-sm" data-toggle="modal"
                    (click)="setJobApply($event)">Postular</a>
            </div>
        </div>
    </div>
</div>